/* eslint-disable no-unused-vars */
import React from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "../About/About.css";

import { Pagination, Navigation, Autoplay } from "swiper/modules";

export default function About() {
  return (
    <div className="Gallery-Wraps contact program gift-cards">
      <main>
        <div className="tp-project__area pb-30">
          <div className="container">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-12 text-center mb-50 mt-10">
                <p className="w-50 m-auto">ABOUT US</p>
                <h4 className="text-left second">About Our Company</h4>
                <p className="m-auto">
                iPhotoCanvas reproduces photographs and fine art works at the highest level. We are a full-service fine art and photography studio. Our facility houses the printing technology and custom framing with a staff of passionate artists, photographers and technicians. We generate our own color profiles from the most sophisticated software in the industry. This color profile enables us to achieve remarkable values of color. These nuances come alive through the digital image on our canvas. Our clients are always amazed to see their photograph transformed into a work of art.
                </p>
              </div>
              <div className="tp-service__area mb-30">
                <div className="container-fluid"></div>
                <div className="container-fluid slider">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="tp-service__wrapper">
                        <div className="swiper-container tp-service__active swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                          <div
                            // className="swiper-wrapper"
                            id="swiper-wrapper-67b855461cc32163"
                            aria-live="polite"
                            >
                            
                            <Swiper
                              slidesPerView={3}
                              spaceBetween={30}
                              centeredSlides={true}
                              // pagination={{
                              //   clickable: true,
                              // }}
                              // modules={[Pagination]}
                              className="mySwiper"
                              loop                                
                             > 
                            
                            <div
                              className="swiper-slide swiper-slide-duplicate"
                              data-swiper-slide-index={2}
                              role="group"
                              aria-label="1 / 11"
                            >
                                <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-3.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                                  </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate"
                              data-swiper-slide-index={3}
                              role="group"
                              aria-label="2 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-1.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev"
                              data-swiper-slide-index={4}
                              role="group"
                              aria-label="3 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-2.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate-active"
                              data-swiper-slide-index={0}
                              role="group"
                              aria-label="4 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-1.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate-next"
                              data-swiper-slide-index={1}
                              role="group"
                              aria-label="5 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-2.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide"
                              data-swiper-slide-index={2}
                              role="group"
                              aria-label="6 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-3.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide"
                              data-swiper-slide-index={3}
                              role="group"
                              aria-label="7 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-1.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-prev"
                              data-swiper-slide-index={4}
                              role="group"
                              aria-label="8 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-2.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            
                            </Swiper>
                          </div>
                          <span
                            className="swiper-notification"
                            aria-live="assertive"
                            aria-atomic="true"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-business__area fix mt-30  container">
          <div
            className="tp-business__bg"
            data-background="assets/img/breadcrumb/slide-page.png"
            style={{
              backgroundSize: "cover",
              backgroundImage: 'url("assets/img/breadcrumb/slide-page.png")',
            }}
          >
            <div className="container">
              <div className="tp-business__item-box mb-20">
                <div className="row row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-3 row-cols-1 arrange-data">
                  <div className="col  col-xl-4 col-lg-4 col-md-12 col-sm-12 ">
                    <div className="tp-business__item text-center">
                      <img src="assets/img/breadcrumb/placehlder.png" alt="" />
                      <h5 className="tp-business__title pt-30">Placeholder</h5>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipi elit.
                        Integer non ante eget nulla efficitur elementum. Donec
                        aliquam dignissim eros.
                      </p>
                    </div>
                  </div>
                  <div className="col   col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <div className="tp-business__item text-center">
                      <img src="assets/img/breadcrumb/placehlder.png" alt="" />
                      <h5 className="tp-business__title pt-30">Placeholder</h5>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipi elit.
                        Integer non ante eget nulla efficitur elementum. Donec
                        aliquam dignissim eros.
                      </p>
                    </div>
                  </div>
                  <div className="col   col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <div className="tp-business__item text-center">
                      <img src="assets/img/breadcrumb/placehlder.png" alt="" />
                      <h5 className="tp-business__title pt-30">Placeholder</h5>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipi elit.
                        Integer non ante eget nulla efficitur elementum. Donec
                        aliquam dignissim eros.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 text-center mb-50">
              <p className="text-left-text">
                iPhotoCanvas reproduces photographs and fine art works at the
                highest level. We are a full-service fine art and photography
                studio. Our facility houses the printing technology and custom
                framing with a staff of passionate artists, photographers and
                technicians.{" "}
              </p>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 text-center mb-50">
              <p className="text-left-text">
                We generate our own color profiles from the most sophisticated
                software in the industry. This color profile enables us to
                achieve remarkable values of color. These nuances come alive
                through the digital image on our canvas. Our clients are always
                amazed to see their photograph transformed into a work of art.
              </p>
            </div>
          </div>
        </div>

        <UpperFooterSlider />
      </main>
    </div>
  );
}
